 
 
    import CardRh from "@/components/cards/ManzaCard.vue" 
    import { Options , Vue  } from "vue-class-component";  
    import {  Prop } from 'vue-property-decorator';    
    
    @Options({
        name: "ControladorEtapa1",
        components: {  CardRh  },   
    }) 
    export default class ControladorEtapa1 extends Vue {
          
        @Prop( ) readonly service!: any 
        @Prop( ) readonly turmas_que_controlo!: any 
        @Prop( ) readonly formData!: any 
        @Prop( ) readonly processando!: any 
         
        public  meses =  ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];  
        public  dias =  ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];  

        public  dia: any =  null ;  
        public  inicio: any =  '07:30' ;  
        public  fim: any =  '08:20' ;  

        get hj() {
            return new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
        } 
        
        get hj2() { 
            return new Date(2020, 2, 1, 0, 33, 0, 0);
        }
         
        mounted() {
            this.dia = new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
        }

        public calculaFim(){ 
            var pos = this.inicio.indexOf(":")
            var hora = parseInt( this.inicio.slice(0, pos) );
            var minuto =  parseInt( this.inicio.slice(  pos + 1 ) ) ; 
            let date = new Date(2020, 2, 1, hora , minuto , 0, 0).getTime() + 3000000;
            let fim = new Date(date) ; 
            this.fim =  ( "0" +  fim.getHours() ).slice(-2) + ':' + ( "0" +  fim.getMinutes() ).slice(-2)   ; 
        } 
        
        public nextPage() {
            this.$emit('nextPage', {
                formData: {
                    data: this.dia,
                    inicio: this.inicio+":00",
                    fim: this.fim+":00"
                },
                pageIndex: 0
            });
        }

        public cancelar() {
            this.$router.push({ name: "sigap_controlador"  }) ;
        }
         
    } 
